module.exports = __webpack_public_path__ + "static/media/fa-regular-400.288d8fc1.eot";